import { Link, Page, Text, View } from '@react-pdf/renderer'
import { Result } from 'antd'
import { PageHeader } from 'components/PageHeader'
import { useRautReportOps } from 'pages/reporting/reports/raut/RautReportProvider'
import { PageFooter } from 'pages/reporting/shared/pdfGeneration/components/shared/PageFooter'
import { PDFStyles } from 'pages/reporting/shared/pdfGeneration/styles/PDFStyles'
import { TOCSection, TOCSectionProps } from 'pages/reporting/shared/types'
import React, { useCallback } from 'react'
import styled from 'styled-components'

const TOCContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
`

const RenderReact: React.FC = () => {
  return (
    <TOCContainer>
      <Result
        status='info'
        title='Table of Contents'
        subTitle='The Table of Contents is automatically generated in the PDF output. Navigate to "Generate PDF" to preview and download the report with the complete table of contents.'
      />
    </TOCContainer>
  )
}

const RenderPDF: React.FC<TOCSectionProps> = ({
  entries,
  sectionPages,
  onRender,
}) => {
  const { formData } = useRautReportOps()

  const handleIndicationCase = useCallback(
    (title: string) => {
      if (title === 'Indications') {
        return formData.mainInfo.scanIndicationMode
          ? 'Scan Overview'
          : 'Indications'
      } else {
        return title
      }
    },
    [formData.mainInfo.scanIndicationMode]
  )

  return (
    <Page size='A4' style={PDFStyles.page} id='toc'>
      <Text
        render={({ pageNumber }) => {
          onRender({ id: 'tableOfContents', pageNumber })
          return ''
        }}
      />

      <PageHeader title='Table of Contents' />

      <View style={PDFStyles.tocTableHeader}>
        <Text style={PDFStyles.tocSectionColumn}>Section</Text>
        <Text style={PDFStyles.tocTitleColumn}>Title</Text>
        <Text style={PDFStyles.tocPageColumn}>Page</Text>
      </View>

      <View style={PDFStyles.contentWithPadding}>
        {entries.map((section, index) => {
          const pageNumber = sectionPages[section.id]
          return (
            <View key={section.id} style={PDFStyles.tocSectionRow}>
              <Text style={PDFStyles.tocSectionNumber}>
                {(index + 1).toFixed(1)}
              </Text>
              <Link
                src={`#${section.id}`}
                style={PDFStyles.tocSectionTitleLink}>
                <Text style={PDFStyles.tocSectionTitle}>
                  {handleIndicationCase(section.title)}
                </Text>
              </Link>
              <View style={PDFStyles.tocDotContainer}>
                <View style={PDFStyles.tocDots} />
              </View>
              <Text style={PDFStyles.tocSectionPage}>
                {pageNumber?.toString() || '-'}
              </Text>
            </View>
          )
        })}
      </View>

      <PageFooter
        jobNumber={formData.coverPageData.geckoJobId}
        revisionNumber={formData.revisionMetadata.revisionNumber}
        prelim={
          !(
            formData.signoff?.reviewerSignoff &&
            formData.signoff.supervisorSignoff
          )
        }
      />
    </Page>
  )
}

export const TOC: TOCSection = {
  id: 'tableOfContents',
  title: 'Table of Contents',
  RenderPDF,
  RenderReact,
}
